// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2l5no","content":"RecentSearches_content__2gkZ0"};